<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { CheckBoxDefinition } from 'header/types';

    interface Props {
        field: CheckBoxDefinition;
    }

    let { field }: Props = $props();

    const dispatch = createEventDispatcher();

    const onChange = (e: { currentTarget: HTMLInputElement }) => {
        dispatch('change', {
            field: {
                ...field,
                value: e.currentTarget.checked,
            },
        });
    };
</script>

<input
    class="input"
    type="checkbox"
    disabled={field.changeable === false}
    checked={field.value}
    onchange={onChange}
/>

<style lang="scss" scoped>
    .input {
        margin-left: 0;
    }
</style>
